import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'
import type {
  ILoginPasswordInputBlockProps,
  ILoginUsernameInputBlockProps,
} from 'blocks/InputBlock/Templates'
import type { IAuthFormBoxProps } from '../AuthFormBox'

import { PrimarySubmitButton } from 'atoms/Button/Templates'
import { InputFonts } from 'atoms/Input'
import { TextBoxMaxLine1Headline1 } from 'atoms/TextBox/Templates'
import {
  LoginPasswordInputBlock,
  LoginUsernameInputBlock,
} from 'blocks/InputBlock/Templates'
import { AuthFormBox } from '../AuthFormBox'
import { AuthFormBoxPaddings, AuthFormBoxRowGaps } from '../AuthFormBox.h'
import { LoginColumn } from '../AuthFormBox.styled'

export interface ISignInAuthFormBoxProps extends Omit<
  IAuthFormBoxProps,
  'children'
> {
  usernameInputType?: ILoginUsernameInputBlockProps['type']
  usernameInputPattern?: ILoginUsernameInputBlockProps['pattern']
  usernameInputRequired?: ILoginUsernameInputBlockProps['required']
  usernameInputDefaultValue?: ILoginUsernameInputBlockProps['defaultValue']
  usernameInputErrorMessage?: ILoginUsernameInputBlockProps['errorMessage']
  passwordInputType?: ILoginPasswordInputBlockProps['type']
  passwordInputPattern?: ILoginPasswordInputBlockProps['pattern']
  passwordInputRequired?: ILoginPasswordInputBlockProps['required']
  passwordInputDefaultValue?: ILoginPasswordInputBlockProps['defaultValue']
  passwordInputErrorMessage?: ILoginPasswordInputBlockProps['errorMessage']
  buttonDisabled?: IButtonProps['disabled']
}

export const SignInAuthFormBox = ({
  usernameInputType = 'text',
  usernameInputPattern,
  usernameInputRequired = true,
  usernameInputDefaultValue = '',
  usernameInputErrorMessage = '',
  passwordInputType = 'text',
  passwordInputPattern,
  passwordInputRequired = true,
  passwordInputDefaultValue = '',
  passwordInputErrorMessage = '',
  buttonDisabled = false,
  width = 432,
  padding = AuthFormBoxPaddings.SIZE_140,
  rowGap = AuthFormBoxRowGaps.SIZE_10,
  ...rest
}: ISignInAuthFormBoxProps): JSX.Element => (
  <AuthFormBox width={width} padding={padding} rowGap={rowGap} {...rest}>
    <TextBoxMaxLine1Headline1 title={'Sign In'} />
    <LoginUsernameInputBlock
      type={usernameInputType}
      pattern={usernameInputPattern}
      required={usernameInputRequired}
      label='Email or Username'
      placeholder='Enter Email or Username'
      defaultValue={usernameInputDefaultValue}
      errorMessage={usernameInputErrorMessage}
      font={InputFonts.Body4}
    />
    <LoginColumn>
      <LoginPasswordInputBlock
        type={passwordInputType}
        pattern={passwordInputPattern}
        required={passwordInputRequired}
        label='Password'
        placeholder='Enter Password'
        defaultValue={passwordInputDefaultValue}
        errorMessage={passwordInputErrorMessage}
        font={InputFonts.Body4}
      />
    </LoginColumn>
    <LoginColumn>
      <PrimarySubmitButton title={'Sign In'} disabled={buttonDisabled} />
    </LoginColumn>
  </AuthFormBox>
)
